import { render, staticRenderFns } from "./SkinAmountChip.vue?vue&type=template&id=2feb526a&scoped=true&"
import script from "./SkinAmountChip.vue?vue&type=script&lang=ts&"
export * from "./SkinAmountChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb526a",
  null
  
)

export default component.exports